import React from 'react';
import Accordion from '@boschebike/ebds-react/dist-esm/components/Accordion.js';
import { RawElement } from '../helpers.js';

/**
 * @typedef {import('../../App.d.ts').AccordionItemProps} AccordionItemProps
 */

/**
 *
 * @param {AccordionItemProps} props
 * @returns {Element}
 */
export default (props) => (
  <Accordion.Item
    data-testid="accordion-item"
    summary={props.summary}
  >
    <RawElement html={props.detailRaw} />
  </Accordion.Item>
);
